import { render } from "./followCenter.vue?vue&type=template&id=de163ece&scoped=true"
import script from "./followCenter.vue?vue&type=script&lang=js"
export * from "./followCenter.vue?vue&type=script&lang=js"

import "./followCenter.vue?vue&type=style&index=0&id=de163ece&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de163ece"]])

export default __exports__